import { render, staticRenderFns } from "./campaigneditor.vue?vue&type=template&id=e1644a74&"
import script from "./campaigneditor.vue?vue&type=script&lang=js&"
export * from "./campaigneditor.vue?vue&type=script&lang=js&"
import style0 from "./campaigneditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports